import React from "react";

import { getImage, ImageType } from "../../../../helpers/imageHelper";
import { useString, useStrings } from "../../../../localization/localizationHelpers";
import { LandingCtaPlacements, useLandingCta } from "../../useLandingCta";
import * as styles from "./PartnerOperateSection.module.css";

type FeatureProps = Readonly<{
  title: string;
  description: string;
}>;

const Feature = ({ title, description }: FeatureProps) => (
  <div className={styles.feature}>
    <h3 className={styles.featureTitle}>{title}</h3>
    <p className={styles.featureDescription}>{description}</p>
  </div>
);

export const PartnerOperateSection = () => {
  const handleGetStarted = useLandingCta(LandingCtaPlacements.operate);

  const [
    eyebrow,
    title,
    servicesTitle,
    servicesDescription,
    freeBadge,
    servicesCaption,
    getStartedLabel,
    enginesTitle,
    enginesDescription,
    optimizeTitle,
    optimizeDescription,
  ] = useStrings(
    "landingOperateEyebrow",
    "landingOperateTitle",
    "landingOperateServicesTitle",
    "landingOperateServicesDescription",
    "landingOperateFreeBadge",
    "landingOperateServicesCaption",
    "landingHeroGetStartedButton",
    "landingBuildEnginesTitle",
    "landingBuildEnginesDescription",
    "landingBuildOptimizeTitle",
    "landingBuildOptimizeDescription"
  );

  const servicesImageAlt = useString("landingOperateServicesImageAlt");

  return (
    <section className={styles.section}>
      <div className={styles.card}>
        <header className={styles.cardHeader}>
          <span className={styles.eyebrow}>{eyebrow}</span>
          <h2 className={styles.title}>{title}</h2>
        </header>
        <div className={styles.highlight}>
          <div className={styles.highlightContent}>
            <h3 className={styles.highlightTitle}>{servicesTitle}</h3>
            <p className={styles.highlightDescription}>{servicesDescription}</p>
            <img
              className={styles.freeBadge}
              src={getImage("badge_free", ImageType.Png)}
              alt={freeBadge}
            />
            <p className={styles.highlightCaption}>{servicesCaption}</p>
            <button className={styles.getStartedButton} onClick={handleGetStarted}>
              {getStartedLabel}
            </button>
          </div>
          <div className={styles.highlightMedia}>
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={getImage("landing_services_screen_mobile", ImageType.Png)}
              />
              <img
                className={styles.highlightImage}
                src={getImage("landing_services_screen_desktop", ImageType.Png)}
                alt={servicesImageAlt}
              />
            </picture>
          </div>
        </div>
        <div className={styles.featureGrid}>
          <Feature title={enginesTitle} description={enginesDescription} />
          <Feature title={optimizeTitle} description={optimizeDescription} />
        </div>
      </div>
    </section>
  );
};
